import { Injectable } from '@angular/core';
import { ApplicationStateService } from './application-state.service';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class AssetService {

    private assetBasePath: string;

    constructor(applicationStateService: ApplicationStateService) {
        this.assetBasePath = environment.assetsBasePath;
        if (environment.assetsAbsoluteUrls) {
            if (!applicationStateService.isOfflineModeEnabled) {
                if (applicationStateService.baseUrl !== undefined) {
                    this.assetBasePath = `${applicationStateService.baseUrl}/${this.assetBasePath}`;
                }
            } else {
                this.assetBasePath = `resources/${this.assetBasePath}`;
            }
        }
    }

    /**
     * Get url to an asset.
     *
     * @param {string} asset
     * @returns {string}
     */
    getUrl(asset: string): string {
        return `${this.assetBasePath}/${asset}`;
    }
}
